import { ImperativeHandler, renderImperatively } from 'antd-mobile/es/utils/render-imperatively';
import { mergeProps } from 'antd-mobile/es/utils/with-default-props';
import React from 'react';

import { InternalToast, ToastProps } from './toast';

let currentHandler: ImperativeHandler | null = null;
let currentTimeout: number | null = null;

export type ToastShowProps = Omit<ToastProps, 'visible'>;

const defaultProps = {
  duration: 2000,
  position: 'center',
  maskClickable: true,
};

export interface ToastHandler {
  close: () => void;
}

const ToastInner = (
  props: ToastShowProps & {
    onClose?: () => void;
  },
) => <InternalToast {...props} />;

export function show(p: ToastShowProps | string) {
  clear();
  const props = mergeProps(defaultProps, typeof p === 'string' ? { content: p } : p);

  const element = (
    <ToastInner
      {...props}
      onClose={() => {
        currentHandler = null;
      }}
    />
  );
  if (currentHandler) {
    currentHandler.replace(element);
  } else {
    currentHandler = renderImperatively(element);
  }

  if (currentTimeout) {
    window.clearTimeout(currentTimeout);
  }
  if (props.duration !== 0) {
    currentTimeout = window.setTimeout(() => {
      clear();
    }, props.duration);
  }

  return currentHandler as ToastHandler;
}

// 新增动画函数
export function showWithAnimation(
  content: string,
  options: {
    startOffset?: number;
    endOffset?: number;
    type?: 'slide-up' | 'slide-down' | 'slide-left' | 'slide-right' | 'fade';
    duration?: number;
  } = {},
) {
  const { startOffset = 30, endOffset = 0, type = 'slide-up', duration = 2000 } = options;

  return show({
    content,
    animationStartOffset: startOffset,
    animationEndOffset: endOffset,
    animationType: type,
    duration,
  });
}

export function clear() {
  currentHandler?.close();
  currentHandler = null;
}

export function config(val: Pick<ToastProps, 'duration' | 'position' | 'maskClickable'>) {
  if (val.duration !== undefined) {
    defaultProps.duration = val.duration;
  }
  if (val.position !== undefined) {
    defaultProps.position = val.position;
  }
  if (val.maskClickable !== undefined) {
    defaultProps.maskClickable = val.maskClickable;
  }
}
